import UpgradeMemberContainer from "../../Component/UpgradeMember/UpgradeMemberContainer";


const UpgradeMember = () => {
  return (
    <div className="page-body">
      <UpgradeMemberContainer />
    </div>
  );
};

export default UpgradeMember;
